<template>
  <div class="booking-screen fade-in">
    <div class="booking-screen__wrapper">
      <v-icon icon="mdi-check-circle" size="64" color="primary" class="icon bounce" />
      <h2 class="text-primary">
        Deine Buchung war erfolgreich
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
  @use '../assets/sass/booking-screen';
</style>
